/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareRightIcon16Solid = forwardRef('RotateSquareRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.219.164a.75.75 0 1 0-.938 1.172l.83.664H4.75A3.75 3.75 0 0 0 1 5.75v3a.75.75 0 0 0 1.5 0v-3A2.25 2.25 0 0 1 4.75 3.5h2.362l-.83.664a.75.75 0 1 0 .937 1.172L8.986 3.92a1.5 1.5 0 0 0 0-2.342L7.22.164Z" }),
        React.createElement("path", { d: "M4 8.5A2.5 2.5 0 0 1 6.5 6h5A2.5 2.5 0 0 1 14 8.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 4 13.5v-5Z" })));
});
